import axios from "axios";
import { LocalStorageUtils } from "../utils/localstorage.utils.jsx";
import { getDeviceType, getDeviceId, getLocation } from "../utils/helper.jsx";
export const makeApi = async (endpoint, method = "GET", data) => {
  try {
    const token = LocalStorageUtils.get(
      LocalStorageUtils.LOCAL_STORAGE_KEY.AUTH_TOKEN
    );
    const deviceType = getDeviceType();
    const deviceId = getDeviceId();
    const areaId =
      LocalStorageUtils.getAreaId() ?? "32b936c4-0313-460a-b9c4-4f674733265e";
    const { latitude, longitude } = (getLocation() ?? {});
    // if (!token && endpoint.includes("/auth-required")) {
    //   throw new Error("Please login to access this resource.");
    // }

    const headers = {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
      "x-access-token": token ? token : "",
      "x-device-type": deviceType,
      "x-device-id": deviceId,
    };

    if(latitude && longitude) {
      headers["x-location-lat-long"] = `${latitude},${longitude}`;
    }

    const config = {
      method,
      url: process.env.REACT_APP_API_BASE_URL + endpoint,
      params: {
        areaId,
      },
      headers,
      data,
    };

    const response = await axios(config);
    return response;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};
